<template>
  <div class="container text-center mt-5">
    <h1 class="display-1">404</h1>
    <p class="lead">Oops! The page you are looking for does not exist.</p>
  </div>
</template>

<script>
export default {
  name: "NotFoundView"
};
</script>
